import React, { useMemo } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { OWASReport } from '@/views/ListReport/Report/Owas';

type RouteParams = {
	file_id?: string;
};

export function Owas(): JSX.Element {
	const history = useHistory();
	const { search } = useLocation();
	const { file_id } = useParams<RouteParams>();

	function handleOnClose(): void {
		const searchParams = new URLSearchParams(search);

		if (searchParams.get('custom_report')) {
			history.push('/custom-reports/files');
			return;
		}

		history.push('/reporting');
	}

	const initialValues = useMemo(
		() => ({
			file_id: file_id ?? ''
		}),
		[file_id]
	);

	return <OWASReport defaultParameters={initialValues} onClose={handleOnClose} />;
}
